<!-- components/Layout/Row.vue -->
<template>
  <div :class="[
    'grid gap-4 mt-6',
    gridCols,
    customClass
  ]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Row',
  props: {
    cols: {
      type: [Number, Object],
      default: 4
    },
    customClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    gridCols () {
      // If cols is a number, apply the same column count across all breakpoints
      if (typeof this.cols === 'number') {
        return `grid-cols-1 md:grid-cols-2 lg:grid-cols-${this.cols}`
      }

      // If cols is an object, apply specific column counts for each breakpoint
      if (typeof this.cols === 'object') {
        const { sm = 1, md = 2, lg = 4 } = this.cols
        return `grid-cols-${sm} md:grid-cols-${md} lg:grid-cols-${lg}`
      }

      // Default fallback
      return 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CardFormatting/Row.vue